<template>
  <div class="login-container">
    <img class="logo" :src="LOGO" />
    <!-- <h4 style="margin-left: 15px">您好！欢迎登录毕胜普！<span style="color:white">{{channelId}}</span></h4> -->
    <h4 style="margin-left: 15px;margin-bottom:35px;">您好！欢迎预约心健康检测服务<span style="color:white">{{channelId}}</span></h4>
    <van-form @submit="verifyCodeLogin" class="loginForm">
      <van-field
        ref="teleNum"
        v-model="clientForm.teleNum"
        name="手机号"
        label="手机号"
        placeholder="手机号"
        :rules="[
          {
            pattern: teleNumPattern,
            required: true,
            message: '请输入正确的手机号',
          },
        ]"
      />
      <!-- <van-field
        v-model="clientForm.code"
        type="text"
        name="图形验证码"
        label="图形验证码"
        placeholder="图形验证码"
        @focus="_getImageVerifyCode"

        :rules="[{ required: true, message: '图形验证码不正确' }]"
      />
      <van-image
        width="80"
        :src="clientForm.codeimg"
        alt=""
        @click="_getImageVerifyCode"
        style="margin-left: 10px;padding-top:16px;margin-right:20px;"
      />
      <van-icon name="replay" size="30" @click="_getImageVerifyCode"/> -->
      <van-field
        v-model="clientForm.verifyCode"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button
            size="small"
            type="primary"
            @click="_sendMobileVerifyCode"
            :disabled="(disabled = !loginBtn.show)"
            color="#4285C3"
          >
            <span v-show="loginBtn.show">获取验证码</span>
            <span v-show="!loginBtn.show" class="count"
              >{{ loginBtn.count }} s 后重新获取</span
            >
          </van-button>
        </template>
      </van-field>
      <div class="disclaimer">
        <van-checkbox class="disclaimer_checkbox" v-model="consented">
        </van-checkbox>
        <span style="font-size: 12px; display: inline">
          本人已阅读并同意
          <router-link to="/appIndex/disclaimer" style="color: #62a0f7"
            >《免责声明》</router-link
          >
        </span>
      </div>

      <div style="margin: 16px">
        <van-button
          block
          type="info"
          native-type="submit"
          :disabled="!consented"
          color="#4285C3"
        >
          登录
        </van-button>
      </div>
      <div style="margin: 10px; text-align: center">
        <span style="font-size: 12px; color: #9b9b9b"
          >未注册手机号验证后将自动登录</span
        >
      </div>
    </van-form>
    <footer>
      <a :href="'https://beian.miit.gov.cn/'" class="footer_content">
        Copyright © {{ year }} 毕胜普生物科技有限公司.
        &nbsp;All&nbsp;rights&nbsp;reserved.&nbsp;&nbsp;&nbsp;&nbsp;
      </a>
      <br />
      <a :href="'https://beian.miit.gov.cn/'" class="footer_content" > 湘ICP备2020021866 </a>
    </footer>
  </div>
</template>
<script type="text/ecmascript-6">
import { loginWithVerifyCode } from "../../api/userService";
import {
  getImageVerifyCode,
  sendMobileVerifyCode,
} from "../../api/verifyCodeService";
import LOGO from "../../assets/logo/HyperBio_icon.png";
// import { setCookie, getCookie, delCookie } from '../utils/util'
// import md5 from 'js-md5'

export default {
  name: "login",
  data() {
    return {
      //渠道商ID
      channelId:"",
      //静态图片资源Logo
      LOGO: LOGO,
      //是否勾选免责声明
      consented: true,
      //copyright Year
      year: new Date().getFullYear(),
      loginBtn: {
        show: true,
        count: 60,
        timer: null,
      },
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      //登录方式：loginTypeList : pwd  verifyCode   QRCode
      clientForm: {
        teleNum: "",
        verifyCode: "",
        code: "",
        randomStr: "",
        codeimg: "",
      },
      //rules前端验证
      rules: {
        teleNum: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      teleNumPattern: /^1[3456789]\d{9}$/,
    };
  },
  // 里面的函数只有调用才会执行
  methods: {
    phoneNumCheck() {
      let phone = this.clientForm.teleNum;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        // this.$notify({ type: "error", message: "请填写正确的手机号" });
        return false;
      }
    },
    //提交表单 ->根据不同登录方式进行登录
    verifyCodeLogin() {
      let params = {
        teleNum: this.clientForm.teleNum,
        verifyCode: this.clientForm.verifyCode,
      };
      if (this.phoneNumCheck() == false) {
        return;
      } else {
        if (params.verifyCode == "") {
          this.$toast.fail('请输入手机验证码');
          return;
        } else {
          loginWithVerifyCode(params)
            .then((res) => {
              if (res.success) {
                //保存token到sessionStorage
                sessionStorage.setItem("teleNum", this.clientForm.teleNum);
                sessionStorage.setItem("logintoken", res.token);
                sessionStorage.setItem("userId", res.data[0].userTeleNum);
                this.$store.state.userId = res.data[0].userTeleNum;
                this.$store.state.teleNum = res.data[0].userTeleNum;
                this.$store.state.token = res.token;
                this.$store.state.isAuthenticated = true;
                //根据角色跳转路径
                this.$router.push({ path: "/appIndex/main" });
              } else {
                this.$notify({ type: "error", message: res.description });
              }
            })
            .catch((e) => {
              console.log(e);
            });
        }
      }
    },
    //获取验证码并显示在对应的地方
    _getImageVerifyCode() {
      //TODO: 这里需要验证手机号码格式
      if (this.phoneNumCheck() == false) {
        //将焦点抓到电话输入框
        this.$refs["teleNum"].focus();
      } else {
        this.clientForm.codeimg = getImageVerifyCode(
          this.clientForm.teleNum,
          new Date().getTime()
        );
      }
    },
    //发送短信验证码
    _sendMobileVerifyCode() {
      let params = {
        imageVerifyCode: this.clientForm.code,
        teleNum: this.clientForm.teleNum,
      };

      if (this.phoneNumCheck() == false) {
        //将焦点抓到电话输入框
        this.$refs["teleNum"].focus();
        return;
      } else {
        // if (this.clientForm.code == "") {
        //   this.$notify({
        //     type: "warning",
        //     message: "请先输入图形验证码再获取'手机验证码'",
        //   });
        //   return;
        // } else {
          this.sendingWait();

          sendMobileVerifyCode(params).then((res) => {
            if (res.success) {
              this.$toast.success("手机验证码已发送")
              // this.$notify({ type: "info", message: "手机验证码已发送。" });
            } else {
              this.$notify({ type: "error", message: res.description });
              setTimeout(this.resetTimer,5000);
            }
          });
        // }
      }
    },
    sendingWait() {
      const TIME_COUNT = 60;
      if (!this.loginBtn.timer) {
        this.loginBtn.show = false;
        this.loginBtn.count = TIME_COUNT;
        this.loginBtn.timer = setInterval(() => {
          if (this.loginBtn.count > 0 && this.loginBtn.count <= TIME_COUNT) {
            this.loginBtn.count--;
          } else {
            this.loginBtn.show = true;
            clearInterval(this.loginBtn.timer);
            this.loginBtn.timer = null;
          }
        }, 1000);
      }
    },
    resetTimer() {
      this.loginBtn.timer = null;
      this.loginBtn.show = true;
    },
  },
  // 创建完毕状态(里面是操作)
  created() {
    sessionStorage.clear();
    // document.title = "心肌缺血检测预约";
    //创建时就获取一个伪图形验证码
    this.clientForm.codeimg = getImageVerifyCode("1997", new Date().getTime());
    // channelId=tongan
    this.channelId = this.$route.query.channelId;
    if(this.channelId){
      sessionStorage.setItem("channelId",this.$route.query.channelId)
    }else{
      sessionStorage.setItem("channelId","");
      console.log("channelId in login page",this.channelId)
    }
    // console.log("渠道商ID",this.channelId);
    // console.log(sessionStorage.getItem("channelId"))
  },
  beforeCreate() {
    document.title = "心肌缺血检测预约";
  },
  mounted(){
    this._getImageVerifyCode();
  }
};
</script>

<style>
/**style for top bar */
.van-nav-bar {
  background: linear-gradient(to right, #77bbe3, #1270c6);
}
#reset /deep/ .van-ellipsis {
  font-size: 18px;
  color: white !important;
}
#reset /deep/ .van-nav-bar__text {
  color: white !important;
}
/** top bar style end*/

/**统一字体 */
/* *{
  font-family: 'PingFang-SC-Semibold';
} */

.loginForm{
  margin-top: 20px;
}
/**下一步按钮，全局样式 */
.nextStepBtn{
  background: linear-gradient(to bottom, #FFC0C2 0%,#DD2228 100%);
  border:0;
  border-radius:10px;
}
</style>

<style scoped>

.login-container {
  /* border-radius: 10px; */
  margin: 20px auto;
  width: 100%;
  background: #fff;
  text-align: left;
  /* padding:20px; */
}

.code-box {
  text-align: center;
}
.codeimg {
  height: 100%;
}

.imageCodeMargin {
  margin-top: 20px;
}

.logo {
  width: 200px;
  height: auto;
  margin: 10px auto 10px 15px;
  vertical-align: middle;
  /* position: absolute; */
  /* top:153px; */
  /* left:10%; */
}

.disclaimer {
  padding: 10px 0 20px 15px;
}
.disclaimer_checkbox {
  display: inline;
  float: left;
  margin-right: 10px;
}

footer {
  margin-top: 30px;
  margin-bottom:80px;
  padding-bottom:80px;
  text-align: center;
}
.footer_content {
  font-size: 10px;
  color: #9b9b9b;
}
</style>